import axiosInstance from "./axiosCommon";

/**
 * Fetch price listing history for a product by product ID.
 * Endpoint: /supplier-quotations/price-listing/<productId>
 *
 * @param {string|number} productId
 * @returns {Promise<Object|Array|null>}
 */
export const fetchPriceListingByProduct = async (productId) => {
  if (!productId) return null;
  const res = await axiosInstance.get(`/supplier-quotations/price-listing/${productId}`);
  return res?.data?.data || null;
};
